import React from "react"
export function ExtraLegroom(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__extra-legroom"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M13.58 15.752V18.5h-1.017v-2.748h1.016zM3.017 2v11.898h2.54V6.019L3.194 2h1.172l4.883 8.305 2.198-1.238L7.269 2h1.173l3.886 6.571.691-.388a3.34 3.34 0 014.296.898l.11.156.079.126a.488.488 0 01-.104.635l-.076.053-6.6 3.718a.517.517 0 01-.64-.108l-.054-.074-1.335-2.255-.063-.085-2.059-3.5.001 6.15.763.001c1.686 0 3.088 1.237 3.28 2.86l.017.182.005.166a.499.499 0 01-.415.502l-.093.008H2.51a.505.505 0 01-.5-.406l-.009-.09V2h1.016zm11.81 12.706l1.991 1.943-.718.701-1.992-1.943.719-.7zm-7.491.184H6.185l-.027.006-.092.008H3.017l.001 1.72h6.547l-.02-.085a2.27 2.27 0 00-1.88-1.626l-.172-.018-.156-.005zm10.665-1.855v.991h-2.816v-.991h2.816zm-4.315-4.076l-.16.082-1.017.576-.029.025-.075.052-2.631 1.48.88 1.488 5.67-3.195-.076-.079a2.316 2.316 0 00-2.398-.497l-.164.068z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__legroom"
        />
      </g>
    </svg>
  )
}
